export const parseDuration = (
  min: number | null | undefined
): { fullStr: string; hr: string; mins: string } => {
  const hr = min
    ? Math.floor(min / 60) < 10
      ? "0" + Math.floor(min / 60)
      : Math.floor(min / 60)
    : "";

  const mins = min
    ? Math.floor(min % 60) < 10
      ? "0" + Math.floor(min % 60)
      : Math.floor(min % 60)
    : "";

  return {
    fullStr: hr.toString() + mins.toString(),
    hr: hr.toString(),
    mins: mins.toString(),
  };
};

export const durationStrToMinutes = (
  value?: string | null
): number | null => {
  if (!value) {
    return null;
  }

  const cleaned = value.replace(/[^0-9]/g, "");

  if (!cleaned) {
    return null;
  }

  const hrPart = cleaned.slice(0, 2);
  const minPart = cleaned.slice(2, 4);

  const hr = hrPart ? parseInt(hrPart, 10) : 0;
  const mins = minPart ? parseInt(minPart, 10) : 0;

  if (Number.isNaN(hr) && Number.isNaN(mins)) {
    return null;
  }

  return hr * 60 + mins;
};
